import { MakeCall } from './createMakeCall';
import { UserSearch } from './types/UserSearch';

export interface UserSearchPayload {
  city: string;
  country: string;
  startDate?: string;
  endDate?: string;
  kinds?: Array<'entire place' | 'private room' | 'shared room'>;
  types?: Array<'house' | 'building' | 'apartment'>;
  minPrice?: number;
  maxPrice?: number;
  currency?: string;
}

export type SaveSearchCall = (
  id: number,
  data: UserSearchPayload,
) => Promise<{ data: UserSearch }>;

const saveSearch =
  (makeCall: MakeCall) => (id: number, data: UserSearchPayload) =>
    makeCall<UserSearch>('POST', `/api/v2/user/${id}/search`, {
      data,
    });
export { saveSearch };
